module.exports = __webpack_public_path__ + "img/pos7_banner1.b31a99e1.png";